export const delayBatchEvent = {
  eventType: {
    auto_reply: "auto_reply",
    reminder: "reminder",
    scheduled_sending: "scheduled_sending",
  },
};
